import { Display } from '../Display/Display';
import Fight from '../Fight/Fight';
import GameStateFactory from '../States/GameStateFactory';
import { GameAnnouncement } from './GameAnnouncement';
import { useEffect } from 'react';
import { pause } from '../../util/MusicPlayer';
import { isMobileGameDevice } from '../../hooks/useMobileGameViewport';
import { useGameWakeLock } from '../../hooks/useGameWakeLock';
import { lockMobileLandscape } from '../../util/mobileFullscreen';

export function Game() {
  useGameWakeLock(isMobileGameDevice());
  useEffect(() => {
    if (!isMobileGameDevice()) return;
    const lock = () => { void lockMobileLandscape(); };
    lock();
    document.addEventListener('fullscreenchange', lock);
    return () => {
      document.removeEventListener('fullscreenchange', lock);
      window.screen.orientation?.unlock?.();
    };
  }, []);
  useEffect(() => () => { if (isMobileGameDevice()) pause(); }, []);
  return (
    <>
      <GameStateFactory />
      <Display />
      <GameAnnouncement />
      {/* <Fight /> */}
    </>
  );
}
